export default "__VITE_ASSET__CkBywU9v__"